import React, { createContext, useState, useEffect } from "react";
import CompaniesDataArrayOfObjects from "../Services/CompaniesDataArrayOfObjects";

export const GlobalStateContext = createContext();

export const GlobalStateProvider = ({ client, title, children }) => {
  const [exchangeName, setExchangeName] = useState(client || "us");
  const [titleData, setTitleData] = useState(title || "S&P 100");

  const [companiesData, setCompaniesData] = useState([]); // Holds all company data
  const [filteredCompanies, setFilteredCompanies] = useState([]); // Holds filtered company data
  const [filters, setFilters] = useState({
    companyNames: [],
    companyCountries: [],
    sectors: [],
  });

  const [messages, setMessages] = useState([]); 
  const clearMessages = () => setMessages([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const data = await CompaniesDataArrayOfObjects(exchangeName);
        setCompaniesData(data); // Store the complete array of objects
        setFilteredCompanies(data); // Default: show all companies
      } catch (error) {
        console.error("Error fetching spreadsheet data:", error);
      }
    };

    fetchData();
  }, []);
  const updateFilters = (newFilters) => {
    clearMessages();
    setFilters((prevFilters) => ({
      ...prevFilters,
      ...newFilters, // Merge previous filters with new selections
    }));
  };
  useEffect(() => {
    const filtered = companiesData.filter((company) => {
      return (
        (filters.companyNames.length === 0 ||
          filters.companyNames.includes(company.companyName)) &&
        (filters.companyCountries.length === 0 ||
          filters.companyCountries.includes(company.companysCountry)) &&
        (filters.sectors.length === 0 ||
          filters.sectors.includes(company.sector))
      );
    });

    setFilteredCompanies(filtered);
  }, [filters, companiesData]);

  return (
    <GlobalStateContext.Provider value={{ 
      exchangeName,
      titleData,
      filteredCompanies, 
      updateFilters, 
      filters,  
      messages, 
      setMessages,
      clearMessages,
    }}>
      {children}
    </GlobalStateContext.Provider>
  );
};
